import { render, staticRenderFns } from "./SubNavMobile.vue?vue&type=template&id=5920a834&"
import script from "./SubNavMobile.vue?vue&type=script&lang=js&"
export * from "./SubNavMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports